import React, { Fragment } from 'react'
import Typography from '@mui/material/Typography'
import Head from 'next/head'

function Feedback() {
  return (
        <Fragment>
          <Head>
            <title>Clubr-Feedback</title>
            <meta name="description" content="Clubr-Feedback"></meta>
            <meta property="og:title" content="Clubr-Feedback<"></meta>
            <meta property="og:description" content="Clubr-Feedback"></meta>
            <meta property="og:image" content="https://clubrstorage.blob.core.windows.net/clubr-img/OGImageHome.jpg"></meta>
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Clubr" />
            <meta property="og:url" content={`https://clubr.in/feedback`} />
          </Head>

          <Typography component="div" sx={{
              minHeight: '100vh',
              pt:8
            }}>
              <h1>Feedback</h1>
            </Typography>
        </Fragment>
  )
}

export default Feedback